<template>
    <FormControl
        required
        label="Address (max 250 characters)"
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_Company_InPersonHostDefinedMeetingLocation_Address,
            )
        "
    >
        <TextInput
            :name="
                RequestBodyKeyEnum.App_Company_InPersonHostDefinedMeetingLocation_Address
            "
            required
        />
    </FormControl>
    <FormControl
        label="Google Maps URL (max 1000 characters)"
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_Company_InPersonHostDefinedMeetingLocation_GoogleMapsUrl,
            )
        "
    >
        <TextInput
            :name="
                RequestBodyKeyEnum.App_Company_InPersonHostDefinedMeetingLocation_GoogleMapsUrl
            "
        />
    </FormControl>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })
</script>
